import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
  Transition,
} from "@headlessui/react";
import { Fragment } from "react";
import bellIcon from "../../images/bellIcon.svg";
import listingImg from "../../images/listingImg.jpg";

const ReminderPopup = ({ isOpen, onClose, data }) => {
  console.log("Data", data);
  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-10" onClose={onClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <DialogBackdrop className="fixed inset-0 bg-gray-500/75" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300 transform"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200 transform"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <DialogPanel className="relative transform overflow-hidden md:rounded-[50px] rounded-[30px] bg-white text-left shadow-xl transition-all sm:w-full sm:max-w-3xl">
                <div className="bg-theme flex items-center justify-center md:h-36 md:py-11 py-8">
                  <img
                    src={bellIcon}
                    className="brightness-[999] md:w-20 w-16"
                    alt=""
                  />
                </div>
                <div className="space-y-6 md:p-11 p-8">
                  <img
                    src={listingImg}
                    className="md:w-[380px] w-[250px] mx-auto rounded-xl"
                    alt=""
                  />
                  {data && data.length > 0 ? (
                    data.map((val) => (
                      <div className="text-center">
                        <DialogTitle className="md:text-4xl text-3xl font-extrabold text-green mb-4">
                          {val.sched_name}
                        </DialogTitle>
                        <div className="mt-2">
                          <p className="md:text-lg text-md text-center text-black">
                            {val.sched_desc} at {val.sched_start_time}.
                          </p>
                        </div>
                      </div>
                    ))
                  ) : (
                    <></>
                  )}
                  <div className="flex justify-center">
                    <button
                      type="button"
                      onClick={onClose}
                      className="py-1.5 px-16 border border-transparent rounded-full text-sm font-normal text-white bg-theme focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-theme cursor-pointer"
                    >
                      Close Window
                    </button>
                  </div>
                </div>
              </DialogPanel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
};

export default ReminderPopup;
